<template>
  <div>
    <backButton></backButton>
    Lottery Page
  </div>
</template>
<script>
import backButton from "../components/backButton.vue";
export default {
  components: {
    backButton: backButton,
  },
  methods: {},
};
</script>
<style lang="scss"></style>
